import { Button, Popover } from 'antd';
import React, { useRef } from 'react';
import { ReactComponent as IconGroup } from '@/images/icons/edm/template-group-group.svg';
import { ReactComponent as IconDown } from '@/images/icons/edm/template-group-down.svg';
import MultiSelectContent from '../multiSelectContent/multiSelectContent';
import classes from './multiSelect.module.scss';
const MultiSelect = ({ dataList, selectedIds, onCheckedChange, getSelectContent, groupNameRender, createItems, manageItems, addItems, addCancel, errorMessage, hidePopover = false, createGroupId, }) => {
    const popoverRef = useRef(null);
    return (React.createElement(Popover, Object.assign({ ref: popoverRef, content: React.createElement(MultiSelectContent, { dataList: dataList, selectedIds: selectedIds, onCheckedChange: onCheckedChange, createItems: createItems, manageItems: () => {
                var _a;
                manageItems();
                (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.close();
            }, addItems: addItems, addCancel: addCancel, errorMessage: errorMessage, createGroupId: createGroupId }), placement: "bottomRight", destroyTooltipOnHide: { keepParent: false }, trigger: "click", overlayClassName: classes.wrapper }, (hidePopover ? { visible: false } : {})),
        React.createElement("div", { className: classes.container },
            React.createElement("span", null,
                React.createElement(Button, { onClick: getSelectContent, type: "text", className: classes.button },
                    React.createElement(IconGroup, null),
                    React.createElement("span", { className: classes.text }, groupNameRender()),
                    React.createElement(IconDown, null))))));
};
export default MultiSelect;
